export default "__VITE_ASSET__BybR101Y__"